import React from 'react';
import ContactInformation from '../../../../shared/contact-information/ContactInformation';
import { ACTIVITY_CALENDAR_INFO_TYPES } from '../../../../constants/ActivityCalendarConst';

const Information = ({ contactInfoList = [], setContactInfoList }) => {
  return (
    <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
      <div className='col-md-12 mb-3'>
        <ContactInformation
          informationTypes={ACTIVITY_CALENDAR_INFO_TYPES}
          setContactInfoList={setContactInfoList}
          contactInfoList={contactInfoList}
          infoFieldKey='field'
          infoValueKey='value'
          isActivityModule={true}
        />
      </div>
    </div>
  );
};

export default Information;
